<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="57rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.addTarget')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>

        <!--content-->
        <v-card-text>
          <div class="form-group col-ty">
            <!--form-row-->
            <div class="form-row">
              <div class="row">
                <div class="col">
                  <c-Input v-model="memberId" v-bind="InputName" :name="'inputName'" class="size02" @input="getDataDebounced"/>
                </div>
                <div class="col">
                  <Select v-model="posIdx" v-bind="selectPos"/>
                </div>
                <div class="col">
                  <Select v-model="deptIdx" v-bind="selectDept"/>
                </div>
                <div class="col">
                  <Select v-model="shiftYn" v-bind="selectShift"/>
                </div>
                <div class="col">
                  <Select v-model="headYn" v-bind="selectHead"/>
                </div>
              </div>
            </div>
          </div>
          <div class="selected-group scrollbar">
            <v-item-group selected-class="bg-active ">
              <v-container>
                <div class="list-group">
                  <div class="list-row"
                       v-for="(item, i) in members"
                       :key="i"
                  >
                    <div class="list-txt">
                      <v-item>
                        <v-card
                          :class="item.selected?'bg-active':''"
                          dark
                          @click="handleForm(item)"
                        >
                          <div class="txt">
                            {{item.memberInfo}}
                          </div>
                        </v-card>
                      </v-item>
                    </div>
                  </div>
                </div>
              </v-container>
            </v-item-group>
          </div>
        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end">
          <c-btn01 v-bind="btnSave" @click="handleForm"/>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    </v-dialog>
</template>

<script setup lang="ts">
import { ref} from 'vue'
import CompanyService from "@/services/company.service";
import MemberService from "@/services/member.service";
import { debounce } from 'lodash'
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import utils from "@/common/Utils";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const emit = defineEmits(['close', 'confirm'])
const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const snackbar = ref(false)
const snackText = ref('')
const memberId = ref('')
const posIdx = ref('')
const deptIdx = ref('')
const shiftYn = ref('')
const targetYn = ref('')
const headYn = ref('')
const memberCnt = ref(0)
const members = ref([])
const targetCnt = ref(0)
const selectDept = ref({items: [{name: computed(() => t('message.department')), value: ''}]})
const selectPos = ref({items: [{name: computed(() => t('message.position')), value: ''}]})

//ui
const btnSave = computed(() => ( {  btnText: t('message.save')} ))
const InputName = computed(() =>( {
  type: 'text',
  placeholder: t('message.name'),
} ))
const selectTarget = computed(() => ( {items: [{name: t('message.target'), value: ''},{name: 'Y', value: 'Y'},{name: 'N', value: 'N'}]} ))
const selectHead = computed(() => ( {items: [{name: t('message.organizationLeader'), value: ''},{name: 'Y', value: 'Y'},{name: 'N', value: 'N'}]} ))
const selectShift = ref( {items: [{name: t('message.shiftWork'), value: ''}]} )

//hook
onBeforeUpdate (()=>{
  members.value = []
})

onUpdated(() => {
  if(!dialog.value)
    return

  getCompanyInfo()
})

//watch
watch(posIdx, (newValue) => {
  getData()
})
watch(deptIdx, (newValue) => {
  getData()
})
watch(shiftYn, (newValue) => {
  getData()
})
watch(targetYn, (newValue) => {
  getData()
})
watch(headYn, (newValue) => {
  getData()
})

//function
const getCompanyInfo=()=>{
  let companyIdx = localStorage.getItem('companyIdx')!='0'?localStorage.getItem('companyIdx'):storeRef.popupIdx.value
  let params = {
    idx: companyIdx,
  }

  CompanyService.getCompany(params).then(
    (response) => {
      if(response.result){
        let posArr:any = {items: [{name: t('message.position'), value: ''}]}
        response.result.posList?.forEach((item)=>{
          posArr.items.push({name:item.treeName, value:item.idx})
        })
        selectPos.value = posArr

        let deptArr:any = {items: [{name: t('message.department'), value: ''}]}
        response.result.deptList?.forEach((item)=>{
          deptArr.items.push({name:item.treeName, value:item.idx})
        })
        selectDept.value = deptArr

        let shiftArr = {items: [{name: t('message.shiftWork'), value: ''}]}
        response.result.shiftList.forEach((item)=>{
          shiftArr.items.push({name:item.shiftName, value:item.idx})
        })
        selectShift.value = shiftArr
      }

      getData()
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const getData=()=>{
  let companyIdx = localStorage.getItem('companyIdx')!='0'?localStorage.getItem('companyIdx'):storeRef.popupIdx.value
  let params = {
    companyIdx: companyIdx,
    memberId: memberId.value,
    posIdx: posIdx.value,
    deptIdx: deptIdx.value,
    shiftIdx: shiftYn.value,
    targetYn: targetYn.value,
    headYn: headYn.value,
  }

  MemberService.getMemberListFilter(params).then(
    (response) => {
      if(response.result){
        let memberArr = []
        response.result.forEach((item)=>{
          memberArr.push({...item, memberInfo:`${item.memberName||t('message.noInfo')}(${item.memberId||t('message.noInfo')}) / ${item.posName||t('message.noInfo')} / ${item.deptName||t('message.noInfo')}`, selected:false})
        })
        members.value = memberArr
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const handleForm=(item)=>{
  if(import.meta.env.MODE == 'development') {
    emit('close', '')
  }
  else{
    emit('confirm', item)
  }
}

const getDataDebounced = debounce(() => {
  //if (!memberId.value || memberId.value.length < 2) return
  getData()
}, 500)

</script>


<style lang="scss">
</style>
